export const Constants = {
  TAG_NAME: 'pop-product-center-popover',
} as const;
